import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TenantCertificationDetailsComponent } from './tenant-certification-details.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { ClipboardModule } from 'ngx-clipboard';

@NgModule({
  declarations: [TenantCertificationDetailsComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatInputModule,
    MatIconModule,
    MatDividerModule,
    ClipboardModule
  ],
  exports: [
    TenantCertificationDetailsComponent
  ],
})
export class TenantCertificationDetailsModule { }
